import {
  NPISearchItemDTO,
  ProviderEntryDTO,
} from 'dtos';
import isNil from 'lodash/isNil';

export default function mapNPISearchItemToProviderEntry(
  item: NPISearchItemDTO | null | undefined,
): ProviderEntryDTO | null {
  return isNil(item) ? null : {
    type: item.isOrganization ? 'Organization' : 'Individual',
    npi: {
      number: item.npi,
      taxonomyCode: item.taxonomyCode,
      type: item.npiType,
    },
    state: item.state,
    firstName: item.firstName,
    middleName: item.middleName,
    lastName: item.lastName,
    credential: item.credential,
    organizationName: item.organizationName,
    formattedNames: item.formattedNames,
  };
}
